<template>
  <div class="flex flex-col md:flex-row md:justify-between">
    <div class="w-64 flex-shrink-0">
      <span class="text-grayDark font-medium" for="press_kit_rss">Photos</span>
    </div>
    <div class="md:ml-8 mt-1 md:mt-0 flex-1 flex items-center justify-between">
      <ImageUploadMultiple
        class="w-full grid grid-cols-2 gap-6"
        name="photo"
        :entity="entity"
        :working="working"
        :images="model.photos"
        :modelId="model.id"
        @updatedMedia="uploadImage"
      />
    </div>
  </div>
</template>

<script>
  import ImageUploadMultiple from '@/components/shared/ImageUploadMultiple';

  export default {
    props: {
      model: Object,
      entity: String,
    },

    components: {
      ImageUploadMultiple,
    },

    data() {
      return {
        working: false,
        form: {
          photoUrl: null,
        }
      }
    },

    computed: {
      updateAction() {
        return this.entity == 'guest' ? 'guest/updateGuest' : 'shows/updateShow'
      },
    },

    methods: {
      update() {
        this.working = true

        this.$store.dispatch(this.updateAction, {
          id: this.model.id,
          photoUrl: this.form.photoUrl,
        })
          .then(() => {
            this.working = false
            this.form.photoUrl = null
          })
          .catch(() => {
            this.working = false
          })
      },

      uploadImage(url) {
        this.form.photoUrl = url
        this.update()
      },
    }
  }
</script>